export const Dictionary = {
  __presentation_1:
    "El sitio para escritores de libros de fantasía, novelas y cuentos con tramas más complejas.",
  __presentation_2:
    "Plotter Studio es una plataforma creada en colaboración con escritores para escritores.",
  __presentation_3: "Escritura de trama basada en eventos",
  __presentation_4: "Orden de tiempo",
  __presentation_5:
    "Mantén todos los eventos clave de tu trama en orden colocándolos en una línea de tiempo. ",
  __presentation_6: "Control",
  __presentation_7:
    "Verifique la coherencia de los eventos insertados, para evitar lagunas o inconsistencias en la trama. ",
  __presentation_8: "Trabajo en equipo",
  __presentation_9:
    "Plotter Studio permite a los usuarios invitar a otros a colaborar en el mismo libro, permitiendo así eficacia profesional incluso en un entorno laboral.",
  __presentation_10: "Interfaz intuitiva",
  __presentation_11:
    "El uso de Plotter Studio se ha optimizado para que sea fácil de usar, de modo que puedas concentrarte en tu libro sin tener que pensar en nada más.",
  __presentation_12: "¿Tiene usted alguna pregunta?",
  __presentation_12_2:
    "El equipo de Plotter Studio está a su disposición para responder a todas sus preguntas",
  __presentation_13: "Contáctanos",
  __presentation_14: "O puedes crear una cuenta gratis ",
  __presentation_14_2:
    "Al registrarte, obtienes un mes de acceso gratuito a la cuenta Mini para probar el sistema.",
  __presentation_15: "Calidad profesional",
  __presentation_16:
    "Plotter Studio es desarrollado y mantenido por un grupo con décadas de experiencia en el mundo TI, y garantizamos evoluciones continuas en el tiempo.",
  __footer_about_us: "Sobre nosotros",
  __footer_our_mission: "Nuestra misión",
  __footer_were_are_we_headed: "¿Hacia dónde nos dirigimos?",
  __footer_privacy: "Política de privacidad",
  __footer_term_of_use: "Términos de servicio",
  __footer_services: "Nuestros servicios",
  __footer_serv_support: "Apoyo a los escritores",
  __footer_serv_teaching: "Enseñando",
  __footer_serv_private_solutions: "Soluciones privadas",
  __footer_contact_us: "Contáctenos",
  __footer_social_media: "Medios de comunicación social",
  __footer_social_facebook: "Facebook",
  __footer_social_twitter: "Twitter",
  __app_for_writers_logo: "La aplicación para escritores",
  __service_support_title: "Soporte Técnico",
  __service_support_desc:
    "¿Tienes algún problema? Descríbenos lo sucedido y nuestro equipo técnico te responderá a la brevedad.",
  __service_teaching_title: "Formación y Enseñanza",
  __service_teaching_desc:
    "¿Quieres dominar nuestras herramientas? Solicita información sobre nuestros cursos y seminarios web.",
  __service_private_title: "Soluciones Privadas",
  __service_private_desc:
    "¿Necesitas una infraestructura dedicada? Hablemos de cómo podemos escalar tu negocio con soluciones a medida.",
  __mission_title: "Empoderando a la próxima generación de narradores",
  __mission_subtitle:
    "Uniendo la imaginación pura con obras maestras estructuradas.",
  __mission_p1_title: "Domando el Caos",
  __mission_p1_desc:
    "Ayudamos a los escritores a superar la inconsistencia. Combinando IA avanzada con herramientas expertas, convertimos la difícil tarea de escribir en un viaje guiado.",
  __mission_p2_title: "Dominando la Complejidad",
  __mission_p2_desc:
    "Los proyectos a gran escala pueden ser abrumadores. Ofrecemos un entorno controlado donde los mundos complejos y los perfiles de personajes se gestionan fácilmente.",
  __mission_founder_title: "Creado por un escritor, para escritores",
  __mission_founder_desc:
    "Creé esta plataforma porque la necesitaba. Como autor de una saga de fantasía, quería una herramienta que entendiera la historia, no solo un lugar donde guardar datos.",
};
